$(document).ready(function (){
    $("#table-pages-authors").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: 'admin/get-pages-authors',
        columns: [
            {data: 'page_author.name', description: 'page_author.name'},
            {data: 'slug', name: 'slug'},
        ],
        "columnDefs": [{
            "targets": 2,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status);
                return '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn btn-' + status.color_clas + ' change-page-author-status btn-sm m-1"  ' +
                    'data-id ="' + row.id + '"><span class="' + status.icon + '"></span></a> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia ' +
                    'edit-page-author btn-sm m-1"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Agregar imagen" class="btn button_almadia_reverse ' +
                    'open-modal-img btn-sm m-1 " data-id =' + row.id + '><i class="fa-solid fa-image"></i>' +

                    '<button data-toggle="tooltip" data-placement="top" title="Agregar lote" class="btn button_almadia ' +
                    'open-modal-sections btn-sm m-1 " data-id =' + row.id + '><i class="fa-solid fa-book"></i></button>' +
                    button_coupon_delete(row.status,row.id)

            }
        }]
    })

    const table_page_authors = $("#table-pages-authors").DataTable();

    $("#btn-pages-authors").on('click', function (e){
        $(".modal-title-pages").html('Configurar página')
        $("#modal-pages").modal('show')
        $(".dir-pages").val('add')
        $('.item-author_id').val('').trigger("chosen:updated")
    })

    $("#table-pages-authors tbody").on('click','.edit-page-author', function (e){
        $(".modal-title-pages").html('Configurar página')
        $("#modal-pages").modal('show')
        rowData = table_page_authors.row($(this).parents('tr')).data()
        $.each(rowData, function (index,value){
            console.log(index,value)
            $(".item-"+index).val(value)
            if (index == "author_id") {
                $('.item-author_id').val(value).trigger("chosen:updated")
            }
        })
        $(".dir-pages").val('edit')
    })

    $("#table-pages-authors tbody").on('click','.change-page-author-status', function (){
        let route = "/admin/change-status-pages-author"
        let id = $(this).data('id')
        let data = new FormData()
        data.append('id',id)
        sendData(data,route)
    })

    $("#table-pages-authors tbody").on('click','.delete-page-author', function (){
        let route = "/admin/delete-pages-author"
        let id = $(this).data('id')
        let data = new FormData()
        data.append('id',id)
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data,route)
            }
        })
    })

    $("#form-pages").on('submit', function (e){
        e.preventDefault()
        let dir = $(".dir-pages").val()
        let data = new FormData(this)
        let route = "/admin/"+ dir +"-pages-author"
        clearSpan()
        sendData(data, route)
    })

    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.success == "success") {
                        $("#modal-pages").modal('hide')
                        $("#table-pages-authors").DataTable().ajax.reload();
                        alertSuccess(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var errors = errors.responseJSON.errors;
                $.each(errors, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }
    function button_coupon_delete(status,id) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-page-author btn-sm m-1"  ' +
                'data-id ="' + id + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ' ;
        }
        return "";
    }


    function clearSpan()
    {
        $(".item-error-author_id").html('')
        $(".item-error-page_color").html('')
        $(".item-error-font_color").html('')
    }



    function viewTableImg(id)
    {
        $("#table-images-pages").DataTable().destroy();
        $("#table-images-pages").DataTable({
            proccesing: true,
            serverSide: true,
            language: {
                url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
            },
            responsive: true,
            ajax: 'admin/get-images-pages/'+id,
            columns: [
                {data: 'id', id: 'id'},
                {data: 'imagen',
                render: function (data,type,row,meta) {
                    console.log(data)
                    return '<img src="../images/banners/' + data + '" alt="Imagen" style="width:100px; height:auto;"/>';
                }
                },
            ],
            "columnDefs": [{
                "targets": 2,
                "data": "download_link",
                "render": function (data, type, row, meta) {
                    let status = get_global_status(row.status);
                    return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                        'delete-image-carrusel btn-sm m-1"' +
                        'data-id ="' + row.id + '"><i class="fa-solid fa-trash-can"></i></button>'
                }
            }]
        })
    }

    $("#table-pages-authors tbody").on('click','.open-modal-img', function (e){
        e.preventDefault()
        let id = $(this).data('id')
        $(".item-id").val(id)
        $("#modal-images").modal('show')
        viewTableImg(id)
    })

    $("#form-img-pages").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendDataImg(data,"/admin/add-img-pages-author")
    })

    $('#table-images-pages').on('click', '.delete-image-carrusel', function() {
        let id = $(this).data('id')
        let data = new FormData()
        data.append('id',id)

        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendDataImg(data,"/admin/delete-image-page/"+id)
            }
        })

    });

    function sendDataImg(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.success == "success") {
                        $(".item-image").val('')
                        $("#table-images-pages").DataTable().ajax.reload();
                        alertSuccess(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var errors = errors.responseJSON.errors;
                $.each(errors, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }




})
